import Vue from 'vue/dist/vue.js'

import individualForm from './partials/individual-form'
if(document.querySelector('#v-individual-form')) individualForm(Vue);
